import { observer } from "mobx-react";
import './index.css';
import SocketStore from "../../stores/SocketStore";
import ScreenShotStore from "../../stores/ScreenShotStore";
import { getShapeIcon, SHAPES, ToolWidth } from "../../helpers/statics";
import { DomPurifyHtml } from "../DomPurifyHtml";

const ScreenShotShapes = () => {

  const handleClick = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    if (ScreenShotStore.selectedShape === 'free-hand' || ScreenShotStore.selectedShape === 'color') {
      return;
    }

    if (ScreenShotStore.selectedShape === 'eraser') {
      const shape = ScreenShotStore.getShapeByCoordinates(x, y);
      if (shape) {
        handleShapeRemove(shape.id);
      }
      return;
    }

    if (ScreenShotStore.selectedShape) {
      ScreenShotStore.addShape(x, y, ScreenShotStore.selectedShape, SocketStore.selectedShapeColor);
    }


  };

  const handleShapeRemove = (id) => {
    ScreenShotStore.removeShape(id);
  }

  return (
    <div className="screen-shot-shapes"

      onClick={handleClick}
    >
      {ScreenShotStore.shapes.map((_shape, index) => (
        <div key={index} className="customer-call-container-shape" style={{
          left: _shape.x - ToolWidth / 2,
          top: _shape.y - ToolWidth / 2
        }}>
          <DomPurifyHtml
            className="customer-call-container-shape-icon"
            html={getShapeIcon(_shape)}
            style={{
              width: ToolWidth,
              height: ToolWidth,
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default observer(ScreenShotShapes);